export default {
  'primary': '#118799',
  'secondary': '#A0C03A',
  'accent': '#00aeb7'
}
